import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import * as backend from "../../helpers/backend_helper";

// First, create the thunk
export const fetchFactories = createAsyncThunk(
    'factories/fetchFactoryies',
    async () => {
        const response = await backend.getAllFactoryByUsers();
        return response
    }
)

const initialState: any = {
    factories: [],
    selected: null,
    error: null,
}


export const FactorySlice = createSlice({
    name: 'factories',
    initialState: initialState,
    reducers: {
        setFactoryies: (state, payload: PayloadAction<any>) => {
            const list = Array.isArray(payload.payload) ? payload.payload : [];
            state.factories = list;
            if (!state.selected && list[0]) {
                state.selected = list[0];
            }
        },
        setSelectedFactory: (state, payload: PayloadAction<any>) => {
            state.selected = payload.payload;
        },
        resetFactoryies: (state) => {
            state.factories = []
            state.selected = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchFactories.fulfilled, (state, action) => {
            const list = Array.isArray(action.payload) ? action.payload : [];
            state.factories = list;
            if (state.selected) {
                // keep the same factory selected but refresh its data; if it is
                // gone (deleted, or a previous account's), fall back to the first.
                const match = list.find((f: any) => String(f._id) === String(state.selected._id));
                state.selected = match || list[0] || null;
            } else {
                state.selected = list[0] || null;
            }
            state.error = null;
        })
        builder.addCase(fetchFactories.rejected, (state, action) => {
            state.error = action.error ? action.error.message : "Failed to load factories";
        })
    }
})


export const { setFactoryies, setSelectedFactory, resetFactoryies } = FactorySlice.actions

export default FactorySlice.reducer